import AxiosHttpClient from 'app/api/AxiosHttpClient';
import { TLocalization, TLocalizationResponse } from 'app/model/Localization';

const getLocalizationPath = (language: string) => `/localization/${language}`;

/**
 * Сервис работы с текстами и переводами
 */
export class LocalizationService {
    private apiClient: AxiosHttpClient = new AxiosHttpClient();

    private readonly DEFAULT_LANGUAGE: string = 'ru';

    library: Map<string, string>;

    /**
     * Загружает бандл с текстами и парсит его в Map с переводами по ключу
     */
    async initialize(): Promise<void> {
        const data: TLocalizationResponse =
            await this.apiClient.executeGetRequest(
                getLocalizationPath(this.DEFAULT_LANGUAGE),
            );

        this.library = new Map(
            data.messages.map(({ key, message }) => [key, message]),
        );

        return;
    }

    /**
     * Запросить перевод по ключу
     * @param key ключ текста
     * @returns перевод текста или ключ, если текст не найден
     */
    translate(key: string): string {
        if (this.library.has(key)) {
            return this.library.get(key);
        } else {
            return key;
        }
    }
}
